import { Injectable, inject } from "@angular/core";
import { Resolve } from "@angular/router";
import { Observable, Subscriber } from "rxjs";

import { LoginService } from "./login.service";
import { SSO } from "./sso";

@Injectable({
    providedIn: "root"
})
export class SSOsResolverService implements Resolve<SSO[]> {
    private loginService = inject(LoginService);

    resolve(): Observable<SSO[]> | Observable<never> {
        return new Observable<SSO[]>((observe: Subscriber<SSO[]>) => {
            this.loginService.listSSOs().subscribe((ssos: SSO[]) => {
                observe.next(ssos);
                observe.complete();
            });
        });
    }
}
